import store from '../../store/store';
import {
  cs
} from 'vuejs-datepicker/dist/locale/';
import moment from 'moment';

export const locale = {
  getLocale: () => {
    const userLocale = store.state.userData.AppActiveUser.localeSettings;
    //middleware
    return {
      dateFormat: (isDatePicker = false) => !isDatePicker ? userLocale.dateFormat : userLocale.datePickerDateFormat,
      timeFormat: () => {
        const timeFormat = userLocale.timeFormat;
        const timeFormatOnly = timeFormat.split(',')[1];
        return timeFormatOnly;
      },
      defaultLanguage: (isDatepicker = false) => {
        if (isDatepicker) {
          const lan = userLocale.defaultLanguage.split('-')[0];
          if (lan === 'cs') {
            return cs;
          } else {
            return cs;
          }
        }
        return userLocale.defaultLanguage;
      },
      formatNumber: number => {
        //only cz
        const lan = userLocale.defaultLanguage.split('-')[0];
        if (lan === 'cs') {
          return String(number).replace('.', ',')
        }
        return String(number).replace('.', ',')
      },
      formatDate: date => {
        return moment(new Date(date)).format(userLocale.dateFormat);
      },
      formatTime: time => {
        return moment(new Date(time)).format(userLocale.timeFormat.split(',')[1]);
      },
      formatTimeFromString: (time, format) => {
        return moment(time, format).format(userLocale.timeFormat.split(',')[1]);
      },
      formatDateTime: date => {
        return moment(date).format(userLocale.dateFormat + ' ' + userLocale.timeFormat.split(',')[1]);
      },
      currency: () => {
        const curr = {
          CZK: 'Kč'
        }
        return curr[userLocale.currency];
      }
    }
  }
}
